import { Skeleton, Table, TableBody, TableCell, TableContainer,  TableRow } from "@mui/material";
import EnhancedTableHead from "../../../../components/Table/TableHead";
import { headCell } from "./tableHeader";
import { CustomTableCell } from "../../styles";
import { LedgerTransactionModalv2 } from "../../TransactionsModal";
import { memo, useCallback,  useState } from "react";
import { CustomTableRow } from "./tableRow";
import { TableFooter } from "./tableFooter";

export const TransactionTable = memo(({
    data,
    accountDetails = {},
    page,
    rowsperpage,
}) => {
    const [openTransactionModal, setopenTransactionModal] = useState(false)
    const handleTransationModal = useCallback((data) => {
        setopenTransactionModal(data)
    }, [])
   
    return <TableContainer
        sx={{
            flexGrow: 1, // Allows table to take remaining space
            overflowY: "auto", // Enables vertical scrolling
            overflowX: "scroll", // Prevents unnecessary horizontal scrolling
            marginX: "10px",
            width: "unset",
            whiteSpace: "nowrap",
        }}
    >
        <Table stickyHeader>
            <EnhancedTableHead
                disableSort={true}
                EnableSearch={false}
                headCell={headCell}
            />
            <TableBody>
                {data?.rows?.slice(
                    page * rowsperpage,
                    page * rowsperpage + rowsperpage
                )
                    .map((data, index) => {
                        return (
                            <CustomTableRow data={data} index={index} handleTransationModal={handleTransationModal} accountDetails={accountDetails} />
                        );
                    })}

                {data.loading == true &&
                    Array.from({ length: 20 }, (_, index) => (
                        <TableRow key={index} >
                            <CustomTableCell colSpan={12}>
                                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                            </CustomTableCell>
                        </TableRow>
                    ))}
                {data.loading == false && data.rows.length == 0 && (
                    <TableRow>
                        <TableCell
                            colSpan={9}
                            rowSpan={10}
                            sx={{ height: "600px", textAlign: "center" }}
                        >
                            No Data !
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
            <TableFooter data={data}/>
        </Table>

        {openTransactionModal &&
            <LedgerTransactionModalv2
                open={openTransactionModal}
                accountId={openTransactionModal}
                onClose={() => setopenTransactionModal(false)}
            />
        }
    </TableContainer>
})
